<script>
//CostFactorMixins.vue
export default {
  data () {
    return {
      operatorsMap: {
        '>': (a, b) => a > b,
        '>=': (a, b) => a >= b,
        '<': (a, b) => a < b,
        '<=': (a, b) => a <= b,
        '==': (a, b) => a === b,
        '!=': (a, b) => a != b,
      },
    }
  },
  computed: {},
  methods: {
    addTime (y) {
      return parseFloat(y[0]) * 60 + parseFloat(y[1]) + parseFloat(y[2]) / 60
    },
    process_price (price, time, cost_list = [], params = []) {
      if (!price) {
        price = time
      }
      let cost = parseFloat(price)
      if (cost_list) {
        for (let factor of cost_list) {
          if (factor.active) {
            let factor_params = factor.parameters
            if (
              !factor_params ||
              this.has_right_parameters(params, factor_params, time, cost)
            ) {
              cost = cost * parseFloat(factor.multiplier)
              cost += factor.flat_fee
            }
          }
        }
      }
      return Math.round(cost)
    },
    has_right_parameters (job_params, factor_params = [], time, cost) {
      //let keys = job_params.keys()
      let self = this
      if (factor_params) {
        for (let param of factor_params) {
          let split_vals = param.split('|')
          let factor_param = split_vals[0]
          let factor_operand = split_vals.length > 0 ? split_vals[1] : '=='
          let factor_val = split_vals.length > 1 ? split_vals[2] : 'True'
          factor_val = self.cast_val(factor_val)
          if (
            factor_param == 'time' &&
            self.operatorsMap[factor_operand](time, factor_val)
          )
            return true
          if (
            factor_param == 'cost' &&
            self.operatorsMap[factor_operand](cost, factor_val)
          )
            return true
          // if (
          //   keys.includes(factor_param) &&
          //   operators_map[factor_operand](job_params[factor_param], factor_val)
          // )
          //   return true
        }
      }
      return false
    },
    cast_val (factor_val) {
      let floatVal = parseFloat(factor_val)
      if (floatVal || floatVal == 0) return floatVal
      else {
        if (['true', 'True'].includes(factor_val)) {
          return true
        } else if (['false', 'False'].includes(factor_val)) {
          return false
        }
      }
      return factor_val
    },
  },
}
</script>
